<template>
    <div class="col-12 col-md justify-content-center">
        <div class="media">
            <div class="media-body">
                <h5 class="mt-0">{{ title }}</h5>
                <p>{{ text }}</p>
            </div>
            <i :class="icon" class="v-icon"></i>
        </div>
    </div>
</template>

<script>
    export default {
        props:['title','icon','text'],
    }
</script>
<style lang="css" scoped>
    .v-icon{
        color:darkgreen;
        font-size: 30px;
        padding: 0 10px;
    }
    .media{
        margin-bottom: 30px;
    }
</style>